import { render, staticRenderFns } from "./LicensingSettings.vue?vue&type=template&id=ef2869c8&scoped=true"
import script from "./LicensingSettings.vue?vue&type=script&lang=js"
export * from "./LicensingSettings.vue?vue&type=script&lang=js"
import style0 from "./LicensingSettings.vue?vue&type=style&index=0&id=ef2869c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2869c8",
  null
  
)

export default component.exports